import { useDispatch } from 'react-redux';

import useMoveToWorkspaceAction from '../../../hooks/useMoveToWorkspaceAction';
import { streamActions } from '../../../store/modules/stream';

type useMoveStreamToWorkspaceActionProps = {
  streamId: string;
};

const useMoveStreamToWorkspaceAction = ({ streamId }: useMoveStreamToWorkspaceActionProps) => {
  const dispatch = useDispatch();
  
  return useMoveToWorkspaceAction({
    onMoveToTeam: () => dispatch(streamActions.moveStreamToTeam({ streamId })),
    onMoveToUser: () => dispatch(streamActions.moveStreamToUser({ streamId }))
  });
};

export default useMoveStreamToWorkspaceAction;
